import React, { Component } from 'react';
import { Divider } from 'react-md';
import { Bar } from 'react-chartjs-2';
import LoadingSpinner from './LoadingSpinner'

const minStepSize = (value) => {
  if (Math.floor(value) === value) {
    return value;
  }
}
export default class BarChartCustom extends Component {

  chartOptions = (labelFormatter) => {
    return {
      barRoundness: 1,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            maxBarThickness: 50,
            display: this.props.showxAxesLabel,

          }
        ], yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
            callback: function (value, index, values) {
             
              if (labelFormatter) {
                return labelFormatter(value);
              }else{
                value = minStepSize(value);
              }
              return value;

            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: this.props.getBarLabel
        }
      }
    }

  };

  render() {
    if (this.props.loading)
      return <LoadingSpinner />

    const chartData = canvas => {
      const ctx = canvas.getContext('2d');
      var gradient = ctx.createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(0, 'rgba(182,4,7,1)');
      gradient.addColorStop(1, 'rgba(24,148,236,1)');
      /***************/

      return {
        labels: this.props.label,
        datasets: [
          {
            data: this.props.data,
            hoverBackgroundColor: 'red',
            borderWidth: 1,
            backgroundColor: gradient,
          }
        ]
      };
    };


if(this.props.data){
  return (

    <div>
      <p style={{fontSize: "medium"}} className={this.props.graphTitleClass} >{this.props.title}</p>
      <Divider className="fullWidth" />
      <br />
      <Bar data={chartData} options={this.chartOptions(this.props.labelFormatter)} />
    </div>

  );
}else{
  return <h5>No data available for {this.props.title}</h5>;
}
    

  }
}
